import { render, staticRenderFns } from "./ArtikelHeader.vue?vue&type=template&id=e64c578c&scoped=true&"
import script from "./ArtikelHeader.vue?vue&type=script&lang=js&"
export * from "./ArtikelHeader.vue?vue&type=script&lang=js&"
import style0 from "./ArtikelHeader.vue?vue&type=style&index=0&id=e64c578c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64c578c",
  null
  
)

export default component.exports